export default __webpack_public_path__ + "static/media/08.22.25 Minutes Reg Mtg.f45d703f.pdf";